/* AIRHOUSE Wishlist 2.0.0 — guest saves and Shopify account synchronization. */
(() => {
  'use strict';
  if (window.AirhouseWishlist) return;
  const configElement = document.getElementById('ah-wishlist-config');
  if (!configElement) return;
  let config;
  try { config = JSON.parse(configElement.textContent); } catch { return; }

  const STORAGE_KEY = 'airhouse:wishlist:v1';
  const accountStore = window.AirhouseWishlistStore || null;
  const root = '/' + String(config.root || '/').replace(/^\/+|\/+$/g, '') + '/';
  const routeRoot = root === '//' ? '/' : root;
  const currency = /^[A-Z]{3}$/.test(config.currency) ? config.currency : 'EUR';
  const locale = config.locale || 'bg-BG';
  const productCache = new Map();
  const rows = new Map();
  const PAGE_SIZE = 24;
  const HEART = '<svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true" focusable="false"><path d="M20.3 4.8a5.2 5.2 0 0 0-7.4 0L12 5.7l-.9-.9a5.2 5.2 0 0 0-7.4 7.4L12 20.5l8.3-8.3a5.2 5.2 0 0 0 0-7.4Z"/></svg>';
  let items = readStorage();
  let visibleCount = PAGE_SIZE;
  let refreshController = null;
  let toastTimer;
  let mountScheduled = false;
  let opener = null;

  function cleanHandle(value) {
    const handle = String(value || '');
    return /^[\p{L}\p{N}][\p{L}\p{N}-]{0,254}$/u.test(handle) ? handle : '';
  }

  function handleFromURL(value) {
    try {
      const url = new URL(value, location.origin);
      if (url.origin !== location.origin) return '';
      const match = url.pathname.match(/\/products\/([^/]+)\/?$/);
      return match ? cleanHandle(decodeURIComponent(match[1])) : '';
    } catch { return ''; }
  }

  function imageURL(value, width = 500) {
    if (!value) return '';
    try {
      const url = new URL(value, location.origin);
      if (!['https:', 'http:'].includes(url.protocol)) return '';
      if (/shopify\.com$|(^|\.)airhouse\.bg$/.test(url.hostname)) {
        url.searchParams.set('width', String(width));
      }
      return url.href;
    } catch { return ''; }
  }

  function normalize(value) {
    if (!value || typeof value !== 'object') return null;
    const handle = cleanHandle(value.handle);
    if (!handle) return null;
    return {
      handle,
      title: String(value.title || 'Продукт').slice(0, 350),
      vendor: String(value.vendor || '').slice(0, 150),
      image: imageURL(value.image),
      price: Number.isFinite(value.price) && value.price >= 0 ? value.price : null,
      compareAt: Number.isFinite(value.compareAt) && value.compareAt >= 0 ? value.compareAt : null,
      addedAt: Number.isFinite(value.addedAt) ? value.addedAt : Date.now()
    };
  }

  function readStorage() {
    if (accountStore) return accountStore.read();
    try {
      const raw = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
      if (!raw || raw.version !== 1 || !Array.isArray(raw.items)) return [];
      const seen = new Set();
      return raw.items.map(normalize).filter(item => {
        if (!item || seen.has(item.handle)) return false;
        seen.add(item.handle);
        return true;
      });
    } catch { return []; }
  }

  function productURL(handle) {
    return routeRoot + 'products/' + encodeURIComponent(handle);
  }

  function has(handle) { return items.some(item => item.handle === handle); }

  function element(tag, className, text) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }

  function button(className, label) {
    const node = element('button', className);
    node.type = 'button';
    node.setAttribute('aria-label', label);
    return node;
  }

  const dialog = element('dialog', 'ah-wishlist-dialog');
  dialog.id = 'ah-wishlist-dialog';
  dialog.setAttribute('aria-labelledby', 'ah-wishlist-heading');
  const headingRow = element('div', 'ah-wishlist-dialog__header');
  const heading = element('h2', 'ah-wishlist-dialog__heading', 'Любими');
  heading.id = 'ah-wishlist-heading';
  const total = element('span', 'ah-wishlist-dialog__total');
  const closeButton = button('ah-wishlist-close', 'Затвори любимите');
  closeButton.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18"/></svg>';
  headingRow.append(heading, total, closeButton);
  const content = element('div', 'ah-wishlist-dialog__content');
  const accountBox = element('div', 'ah-wishlist-account');
  accountBox.hidden = !accountStore;
  const accountCopy = element('div', 'ah-wishlist-account__copy');
  const accountTitle = element('p', 'ah-wishlist-account__title');
  const accountDescription = element('p', 'ah-wishlist-account__description');
  accountDescription.setAttribute('role', 'status');
  accountCopy.append(accountTitle, accountDescription);
  const accountAction = button('ah-wishlist-account__action', 'Влез в профила си');
  const accountLogout = button('ah-wishlist-account__logout', 'Изход от профила');
  accountLogout.textContent = 'Изход';
  accountBox.append(accountCopy, accountAction, accountLogout);
  const empty = element('div', 'ah-wishlist-empty');
  const emptyIcon = element('span', 'ah-wishlist-empty__icon');
  emptyIcon.innerHTML = HEART;
  const emptyTitle = element('h3', '', 'Твоите любими започват оттук');
  const emptyCopy = element('p', '', 'Натисни сърцето до продукт, за да го запазиш за по-късно.');
  const continueButton = button('ah-wishlist-primary', 'Продължи разглеждането');
  continueButton.textContent = 'Продължи разглеждането';
  empty.append(emptyIcon, emptyTitle, emptyCopy, continueButton);
  const grid = element('ul', 'ah-wishlist-grid');
  grid.setAttribute('aria-label', 'Запазени продукти');
  const more = button('ah-wishlist-more', 'Покажи още любими');
  const retry = button('ah-wishlist-retry', 'Опитай отново да обновиш продуктите');
  retry.textContent = 'Опитай отново';
  retry.hidden = true;
  const loadStatus = element('p', 'ah-wishlist-load-status');
  loadStatus.setAttribute('role', 'status');
  const note = element('p', 'ah-wishlist-note', 'Любимите се запазват в този браузър.');
  content.append(accountBox, empty, grid, more, loadStatus, retry, note);
  dialog.append(headingRow, content);
  const toast = element('div', 'ah-wishlist-toast');
  toast.setAttribute('role', 'status');
  toast.setAttribute('aria-live', 'polite');
  toast.hidden = true;
  const toastText = element('span');
  const toastLink = button('ah-wishlist-toast__link', 'Виж любимите');
  toastLink.textContent = 'Виж любимите';
  toastLink.hidden = true;
  toast.append(toastText, toastLink);
  document.body.append(dialog, toast);

  function notify(message, showLink = false) {
    clearTimeout(toastTimer);
    toastText.textContent = message;
    toastLink.hidden = !showLink;
    toast.hidden = false;
    toastTimer = setTimeout(() => { toast.hidden = true; }, 4500);
  }

  function commit(next, message, showLink = false) {
    try {
      if (accountStore) accountStore.setItems(next);
      else localStorage.setItem(STORAGE_KEY, JSON.stringify({ version: 1, items: next }));
    } catch (cause) {
      notify(cause.code === 'LIMIT' ? 'Можеш да запазиш до 500 любими продукта.' : 'Запазването не е възможно. Провери настройките за съхранение на браузъра.');
      return false;
    }
    items = next;
    syncButtons();
    if (dialog.open) renderList();
    if (message) notify(message, showLink);
    document.dispatchEvent(new CustomEvent('ah:wishlist:changed', { detail: { count: items.length } }));
    return true;
  }

  function toggle(product) {
    const normalized = normalize(product);
    if (!normalized) return;
    if (accountStore) {
      try {
        const added = accountStore.toggle(normalized);
        notify(added ? 'Добавено в любимите' : 'Премахнато от любимите', added);
      } catch (cause) {
        notify(cause.code === 'LIMIT' ? 'Можеш да запазиш до 500 любими продукта.' : 'Не успяхме да запазим промяната. Опитай отново.');
      }
      return;
    }
    const latest = readStorage();
    if (latest.some(item => item.handle === normalized.handle)) {
      commit(latest.filter(item => item.handle !== normalized.handle), 'Премахнато от любимите');
    } else {
      commit([{ ...normalized, addedAt: Date.now() }, ...latest], 'Добавено в любимите', true);
    }
  }

  function productFromCard(card) {
    const link = card.querySelector('.product-card__media');
    const title = card.querySelector('.product-card__info .product-title');
    const image = card.querySelector('.product-card__image--primary');
    return {
      handle: handleFromURL(link?.href || '') || cleanHandle(card.getAttribute('handle')),
      title: title?.textContent.trim() || image?.alt || 'Продукт',
      vendor: card.querySelector('.vendor')?.textContent.trim() || '',
      image: image?.currentSrc || image?.getAttribute('src') || ''
    };
  }

  function makeToggle(product, context) {
    const node = button('ah-wishlist-toggle', 'Добави в любими');
    node.dataset.ahWishlistHandle = product.handle;
    node.dataset.ahWishlistTitle = product.title || 'Продукт';
    node.dataset.ahWishlistContext = context;
    node.innerHTML = HEART;
    return node;
  }

  function syncButtons() {
    document.querySelectorAll('[data-ah-wishlist-handle]').forEach(node => {
      const saved = has(node.dataset.ahWishlistHandle);
      node.setAttribute('aria-pressed', String(saved));
      node.setAttribute('aria-label', (saved ? 'Премахни от любими: ' : 'Добави в любими: ') + node.dataset.ahWishlistTitle);
    });
    document.querySelectorAll('[data-ah-wishlist-open]').forEach(node => {
      node.setAttribute('aria-label', items.length ? 'Любими: ' + items.length + ' продукта' : 'Любими');
      node.setAttribute('aria-expanded', String(dialog.open));
      const count = node.querySelector('.ah-wishlist-count');
      if (count) {
        count.textContent = items.length > 99 ? '99+' : String(items.length);
        count.hidden = items.length === 0;
      }
    });
  }

  function mount() {
    mountScheduled = false;
    document.querySelectorAll('product-card.product-card').forEach(card => {
      const info = card.querySelector(':scope > .product-card__info');
      const product = productFromCard(card);
      if (!info || !product.handle) return;
      info.classList.add('ah-wishlist-card-info');
      let heart = info.querySelector(':scope > .ah-wishlist-toggle');
      if (!heart) {
        heart = makeToggle(product, 'card');
        info.append(heart);
      }
      heart.dataset.ahWishlistHandle = product.handle;
      heart.dataset.ahWishlistTitle = product.title;
    });
    document.querySelectorAll('.header__secondary-nav').forEach(nav => {
      const list = nav.querySelector('ul');
      if (!list || list.querySelector('.ah-wishlist-header-item')) return;
      const item = element('li', 'ah-wishlist-header-item');
      const openButton = button('ah-wishlist-header-button', 'Любими');
      openButton.dataset.ahWishlistOpen = '';
      openButton.setAttribute('aria-controls', dialog.id);
      openButton.setAttribute('aria-haspopup', 'dialog');
      openButton.innerHTML = HEART;
      const count = element('span', 'ah-wishlist-count');
      count.setAttribute('aria-hidden', 'true');
      openButton.append(count);
      item.append(openButton);
      list.insertBefore(item, list.querySelector('.header__cart-link'));
      nav.classList.add('ah-wishlist-header-nav');
      nav.closest('x-header')?.classList.add('ah-wishlist-header');
    });
    const product = normalize(config.product);
    if (product) {
      document.querySelectorAll('.product-info buy-buttons:not([template])').forEach(buy => {
        if (buy.closest('quick-buy-modal') || buy.querySelector('.ah-wishlist-toggle')) return;
        if (!buy.querySelector('button[type="submit"]')) return;
        buy.classList.add('ah-wishlist-buy-buttons');
        buy.append(makeToggle(product, 'product'));
      });
    }
    syncButtons();
  }

  function money(cents) {
    if (!Number.isFinite(cents)) return '';
    try { return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(cents / 100); }
    catch { return (cents / 100).toFixed(2) + ' ' + currency; }
  }

  function makeRow(item) {
    const row = element('li', 'ah-wishlist-item');
    row.dataset.ahWishlistItem = item.handle;
    const media = element('a', 'ah-wishlist-item__media');
    media.href = productURL(item.handle);
    const img = element('img');
    img.width = 500;
    img.height = 500;
    img.loading = 'lazy';
    img.decoding = 'async';
    img.alt = item.title;
    if (item.image) img.src = imageURL(item.image);
    media.append(img);
    const info = element('div', 'ah-wishlist-item__info');
    const vendor = element('p', 'ah-wishlist-item__vendor', item.vendor);
    vendor.hidden = !item.vendor;
    const title = element('h3', 'ah-wishlist-item__title');
    const titleLink = element('a', '', item.title);
    titleLink.href = productURL(item.handle);
    title.append(titleLink);
    const prices = element('div', 'ah-wishlist-item__prices');
    const status = element('p', 'ah-wishlist-item__status', 'Обновяване…');
    const remove = button('ah-wishlist-remove', 'Премахни от любими: ' + item.title);
    remove.dataset.ahWishlistRemove = item.handle;
    remove.innerHTML = HEART;
    remove.setAttribute('aria-pressed', 'true');
    const view = element('a', 'ah-wishlist-item__view', 'Виж продукта');
    view.href = productURL(item.handle);
    info.append(vendor, title, prices, status, view, remove);
    row.append(media, info);
    rows.set(item.handle, { row, media, img, vendor, titleLink, prices, status, view });
    updateRow(item.handle);
    return row;
  }

  function updateRow(handle) {
    const refs = rows.get(handle);
    const cached = productCache.get(handle);
    if (!refs || !cached) return;
    const { data, state } = cached;
    refs.prices.replaceChildren();
    if (data) {
      refs.titleLink.textContent = data.title;
      refs.img.alt = data.title;
      if (data.image) refs.img.src = imageURL(data.image);
      refs.vendor.textContent = data.vendor;
      refs.vendor.hidden = !data.vendor;
      refs.prices.append(element('span', '', money(data.price)));
      if (data.compareAt > data.price && data.price > 0) {
        refs.prices.append(element('s', '', money(data.compareAt)));
      }
    }
    for (const link of [refs.media, refs.titleLink, refs.view]) {
      if (state === 'missing') {
        link.removeAttribute('href');
        link.setAttribute('aria-disabled', 'true');
      } else {
        link.href = productURL(handle);
        link.removeAttribute('aria-disabled');
      }
    }
    refs.view.hidden = state === 'missing';
    if (state === 'missing') refs.status.textContent = 'Продуктът вече не се предлага';
    else if (state === 'error') refs.status.textContent = 'Цената не е потвърдена. Провери в продукта.';
    else refs.status.textContent = data?.available ? '' : 'Изчерпан';
    refs.status.hidden = !refs.status.textContent;
  }

  function renderList() {
    const focusedHandle = document.activeElement?.dataset?.ahWishlistRemove;
    const previousIndex = focusedHandle ? items.findIndex(item => item.handle === focusedHandle) : -1;
    rows.clear();
    const shown = items.slice(0, visibleCount);
    grid.replaceChildren(...shown.map(makeRow));
    total.textContent = String(items.length);
    empty.hidden = items.length > 0;
    grid.hidden = items.length === 0;
    note.hidden = items.length === 0 || !!accountStore;
    more.hidden = items.length <= visibleCount;
    more.textContent = 'Покажи още (' + Math.max(0, items.length - visibleCount) + ')';
    if (focusedHandle) {
      const nextHandle = has(focusedHandle) ? focusedHandle : shown[Math.max(0, previousIndex)]?.handle || shown.at(-1)?.handle;
      const nextRow = nextHandle ? rows.get(nextHandle)?.row : null;
      (nextRow?.querySelector('[data-ah-wishlist-remove]') || continueButton).focus({ preventScroll: true });
    }
    refreshVisible(shown);
  }

  async function refreshVisible(shown) {
    refreshController?.abort();
    refreshController = new AbortController();
    const controller = refreshController;
    grid.removeAttribute('aria-busy');
    retry.hidden = true;
    loadStatus.textContent = '';
    const queue = shown.filter(item => {
      const entry = productCache.get(item.handle);
      return !entry || entry.state !== 'loaded' || Date.now() - entry.checkedAt > 60000;
    });
    if (!queue.length || !dialog.open) return;
    grid.setAttribute('aria-busy', 'true');
    let index = 0;
    let failed = false;
    async function worker() {
      while (index < queue.length && !controller.signal.aborted) {
        const item = queue[index++];
        try {
          const response = await fetch(productURL(item.handle) + '.js', {
            headers: { Accept: 'application/json' },
            credentials: 'same-origin',
            signal: controller.signal,
            cache: 'no-cache'
          });
          if (controller.signal.aborted) return;
          if (response.status === 404 || response.status === 410) {
            productCache.set(item.handle, { state: 'missing', checkedAt: Date.now() });
          } else {
            if (!response.ok) throw new Error('Product request failed');
            const product = await response.json();
            if (controller.signal.aborted) return;
            const data = normalize({ ...product, image: product.featured_image, compareAt: product.compare_at_price });
            if (!data || !Number.isFinite(data.price)) throw new Error('Invalid product response');
            productCache.set(item.handle, { data: { ...data, available: product.available === true }, state: 'loaded', checkedAt: Date.now() });
          }
        } catch (error) {
          if (controller.signal.aborted) return;
          failed = true;
          productCache.set(item.handle, { ...productCache.get(item.handle), state: 'error', checkedAt: 0 });
        }
        updateRow(item.handle);
      }
    }
    await Promise.all(Array.from({ length: Math.min(4, queue.length) }, worker));
    if (refreshController !== controller || controller.signal.aborted) return;
    grid.removeAttribute('aria-busy');
    retry.hidden = !failed;
    loadStatus.textContent = failed ? 'Някои продукти не се обновиха. Можеш да опиташ отново.' : '';
  }

  function open(source) {
    if (dialog.open) return;
    if (typeof dialog.showModal !== 'function') {
      notify('Обнови браузъра, за да отвориш любимите.');
      return;
    }
    opener = source instanceof HTMLElement ? source : document.activeElement;
    items = readStorage();
    visibleCount = PAGE_SIZE;
    toast.hidden = true;
    dialog.showModal();
    document.documentElement.classList.add('ah-wishlist-open');
    content.scrollTop = 0;
    renderList();
    syncButtons();
    closeButton.focus({ preventScroll: true });
    if (accountStore) void accountStore.opened();
  }

  function close() { if (dialog.open) dialog.close(); }

  closeButton.addEventListener('click', close);
  continueButton.addEventListener('click', close);
  toastLink.addEventListener('click', () => open(toastLink));
  more.addEventListener('click', () => {
    const firstNew = items[visibleCount]?.handle;
    visibleCount += PAGE_SIZE;
    renderList();
    if (firstNew) rows.get(firstNew)?.row.querySelector('[data-ah-wishlist-remove]')?.focus({ preventScroll: true });
  });
  retry.addEventListener('click', () => refreshVisible(items.slice(0, visibleCount)));
  dialog.addEventListener('close', () => {
    refreshController?.abort();
    grid.removeAttribute('aria-busy');
    document.documentElement.classList.remove('ah-wishlist-open');
    syncButtons();
    const focusTarget = opener?.isConnected && !opener.closest('[hidden]') ? opener : document.querySelector('[data-ah-wishlist-open]');
    focusTarget?.focus({ preventScroll: true });
  });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
  });
  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    const launcher = target.closest('[data-ah-wishlist-open]');
    if (launcher) {
      event.preventDefault();
      open(launcher);
      return;
    }
    const remove = target.closest('[data-ah-wishlist-remove]');
    if (remove) {
      event.preventDefault();
      if (accountStore) {
        try { accountStore.remove(remove.dataset.ahWishlistRemove); notify('Премахнато от любимите'); }
        catch { notify('Не успяхме да запазим промяната. Опитай отново.'); }
        return;
      }
      const latest = readStorage();
      commit(latest.filter(item => item.handle !== remove.dataset.ahWishlistRemove), 'Премахнато от любимите');
      return;
    }
    const heart = target.closest('.ah-wishlist-toggle');
    if (!heart) return;
    event.preventDefault();
    event.stopPropagation();
    const card = heart.closest('product-card');
    toggle(card ? productFromCard(card) : config.product);
  }, true);
  window.addEventListener('storage', event => {
    if (accountStore) return;
    if (event.key !== STORAGE_KEY && event.key !== null) return;
    items = readStorage();
    syncButtons();
    if (dialog.open) renderList();
  });

  const relevant = 'product-card,.product-card__info,.header__secondary-nav,buy-buttons';
  new MutationObserver(records => {
    const changed = records.some(record => {
      if (record.type === 'attributes') return !!record.target.closest('product-card');
      return Array.from(record.addedNodes).some(node => node instanceof Element && (node.matches(relevant) || node.querySelector(relevant)));
    });
    if (!changed || mountScheduled) return;
    mountScheduled = true;
    requestAnimationFrame(mount);
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['handle', 'href'] });

  function updateAccount(state) {
    if (!accountStore) return;
    accountAction.disabled = state.connecting || state.syncing;
    accountLogout.disabled = state.connecting || state.syncing;
    accountLogout.hidden = state.mode !== 'account';
    accountAction.hidden = state.connected && !state.error && !state.pending;
    accountBox.dataset.state = state.error ? 'error' : state.connected ? 'connected' : 'guest';
    if (state.connecting) {
      accountTitle.textContent = 'Свързване с профила…';
      accountDescription.textContent = 'Връщаме те към любимите след вход.';
    } else if (state.syncing) {
      accountTitle.textContent = 'Синхронизиране на любимите…';
      accountDescription.textContent = 'Обновяваме списъка в профила ти.';
    } else if (state.error) {
      accountTitle.textContent = state.pending ? 'Има незапазени промени в профила' : 'Връзката с профила не се осъществи';
      accountDescription.textContent = state.pending ? 'Промените остават на това устройство. Опитай отново, за да ги запазиш и в профила.' : 'Можеш да продължиш разглеждането и да опиташ отново.';
    } else if (state.connected && !state.pending) {
      accountTitle.textContent = 'Любимите са запазени в профила ти';
      accountDescription.textContent = 'Виждаш ги от всяко устройство след вход в същия профил.';
    } else {
      accountTitle.textContent = 'Запази любимите в профила си';
      accountDescription.textContent = 'Влез, за да ги виждаш и от друг телефон или компютър.';
    }
    const label = state.error ? (state.connected ? 'Опитай отново' : 'Влез в профила си') : 'Влез в профила си';
    accountAction.textContent = label;
    accountAction.setAttribute('aria-label', label);
  }
  accountAction.addEventListener('click', () => {
    if (!accountStore) return;
    const state = accountStore.status();
    if (state.connected) void accountStore.refresh();
    else void accountStore.login();
  });
  accountLogout.addEventListener('click', () => { if (accountStore) void accountStore.logout(); });
  if (accountStore) {
    accountStore.subscribe((next, state) => {
      const changed = JSON.stringify(items) !== JSON.stringify(next);
      items = next;
      syncButtons();
      updateAccount(state);
      if (dialog.open && changed) renderList();
      if (accountStore.shouldOpen && !dialog.open) open(document.querySelector('[data-ah-wishlist-open]'));
    });
    updateAccount(accountStore.status());
  }
  window.AirhouseWishlist = Object.freeze({ version: '2.0.0', open, close, has, get count() { return items.length; } });
  mount();
  if (accountStore) void accountStore.start();
})();
